import { render, staticRenderFns } from "./drink-record.vue?vue&type=template&id=a1a97f52&scoped=true&"
import script from "./drink-record.vue?vue&type=script&lang=js&"
export * from "./drink-record.vue?vue&type=script&lang=js&"
import style0 from "./drink-record.vue?vue&type=style&index=0&id=a1a97f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a97f52",
  null
  
)

export default component.exports